export enum Intent {
    DEFAULT,
    PRIMARY,
    WARNING,
    DANGER,
    SUCCESS
}

export function classByIntent(intent?: Intent): string {
    switch (intent) {
        case Intent.DANGER:
            return 'intent-danger';
        case Intent.SUCCESS:
            return 'intent-success';
        case Intent.WARNING:
            return 'intent-warning';
        case Intent.PRIMARY:
            return 'intent-primary';
        default:
            return '';
    }
}

export function classWithIntent(className: string, intent?: Intent): string {
    return [className, classByIntent(intent)].join(' ');
}
